import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { PageMetaData } from '@digital-platform/rs-meta/domain';

@Injectable({
  providedIn: 'root',
})
export class MetaDataService {
  private title = inject(Title);
  private meta = inject(Meta);
  private doc = inject(DOCUMENT);

  public setMetaData(meta?: PageMetaData): void {
    Object.entries(meta ?? {}).forEach(([tag, value]) => {
      if (tag === 'title') {
        this.title.setTitle(value ?? 'Republic Services');
      } else if (tag === 'canonical_url') {
        this.updateOrRemoveCanonicalLink(value);
      } else {
        this.updateOrRemoveMetaTag(tag, value);
      }
    });
  }

  private updateOrRemoveMetaTag(name: string, content?: string): void {
    if (content) {
      this.meta.updateTag({ name, content });
    } else {
      this.meta.removeTag(`name="${name}"`);
    }
  }

  private updateOrRemoveCanonicalLink(canonicalUrl?: string): void {
    let link = this.doc.querySelector(`link[rel="canonical"]`);

    if (canonicalUrl) {
      if (!link) {
        link = this.doc.createElement('link');
        link.setAttribute('rel', 'canonical');
        this.doc.head.appendChild(link);
      }

      link.setAttribute('href', canonicalUrl);
    } else {
      link?.remove();
    }
  }
}
